import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Resume.scss';
import { images } from '../../constants';

const RESUME_ID = '135e0NSOn3ZcMqe-MfSfe06ybi5v0LaWq';
const DRIVE_EMBED_URL = `https://drive.google.com/file/d/${RESUME_ID}/preview`;
const DRIVE_VIEW_URL = `https://drive.google.com/file/d/${RESUME_ID}/view?usp=sharing`;
const DRIVE_DOWNLOAD_URL = `https://drive.google.com/uc?export=download&id=${RESUME_ID}`;
const IFRAME_TIMEOUT_MS = 5000;

const Resume = () => {
  const navigate = useNavigate();
  const [iframeFailed, setIframeFailed] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => setIframeFailed(true), IFRAME_TIMEOUT_MS);
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleIframeLoad = () => {
    clearTimeout(timeoutRef.current);
  };

  return (
    <div className="app__resume">
      <header className="app__resume-header">
        <div className="app__resume-identity">
          <div className="app__resume-avatar">
            <img src={images.faceLogo} alt="logo" />
          </div>
          <div className="app__resume-greeting">
            <span className="app__resume-name">Lovish Tater</span>
            <span className="app__resume-label">Resume</span>
          </div>
        </div>
        <button
          className="app__resume-cta"
          onClick={() => navigate('/?from=resume')}
        >
          View Lovish's Portfolio →
        </button>
      </header>

      <div className="app__resume-body">
        {iframeFailed ? (
          <div className="app__resume-fallback">
            <span className="app__resume-fallback-icon">📄</span>
            <p className="app__resume-fallback-title">Couldn't load the resume preview</p>
            <p className="app__resume-fallback-subtitle">
              Your browser blocked the embedded view.
            </p>
            <a
              href={DRIVE_VIEW_URL}
              target="_blank"
              rel="noreferrer"
              className="app__resume-btn primary"
            >
              Open Resume on Google Drive ↗
            </a>
          </div>
        ) : (
          <iframe
            className="app__resume-iframe"
            src={DRIVE_EMBED_URL}
            title="Lovish Tater Resume"
            onLoad={handleIframeLoad}
          />
        )}

        {!iframeFailed && (
          <div className="app__resume-actions">
            <a
              href={DRIVE_DOWNLOAD_URL}
              target="_blank"
              rel="noreferrer"
              className="app__resume-btn primary"
            >
              ⬇ Download PDF
            </a>
            <a
              href={DRIVE_VIEW_URL}
              target="_blank"
              rel="noreferrer"
              className="app__resume-btn secondary"
            >
              🔗 Open in Drive
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Resume;
